import request from '@/utils/request';

// 会员数据列表
export function getMemberDataList(values) {
  return request('/member-report/queryMemberData', {
    method: 'POST',
    data: values,
  });
}
// 会员数据-详情-订单记录
export function getMemberDataOrderRecords(values) {
  return request('/member-report/queryMemberDataOrderRecords', {
    method: 'POST',
    data: values,
  });
}
// 会员数据-详情-兑礼记录
export function getMemberDataGiftRecords(values) {
  return request('/member-report/queryMemberDataGiftRecords', {
    method: 'POST',
    // data: values,
    data: {
      sort: values.sort,
      memberId: values.memberId,
      pageNum: values.giftPageNum,
      pageSize: values.giftPageSize,
    },
  });
}
// 会员数据-详情-导购通标签
export function getMemberDataDgTags(values) {
  return request('/member-report/queryMemberDataDgTags', {
    method: 'POST',
    data: {
      id: values.memberId,
    },
  });
}
// 会员数据-详情-会员基础信息
export function getMemberDataDetails(values) {
  return request('/member-report/queryMemberDataMemberDetails', {
    method: 'POST',
    data: values,
  });
}
